import React, { useEffect, useState } from "react";
import Dropdown from "../../../components/Dropdown";
import noAvatar from "../../../../assets/img/noAvatar.png";
import { Link } from "react-router-dom";
import AvatarDialog from "./AvatarDialog";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { getTalentDetail, updateBasicInformation } from "../../../reducers/talentMypage";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSnackbar } from "notistack";
import { getItemsDay, getItemsMonth, getItemsYear, getNameByObject, getObjectByName, getObjectById } from "utils/util";
import { WORKING_AGE } from '../../../constants/index'
import { LoadingSpinner } from './../../../components/Icons'
import { formatName } from "utils/format";
import TextInput from "../../../components/TextInput";
import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import {currentUserActions} from '../../../reducers/currentUser'
import {useNavigate} from "react-router-dom";
import { validateRequired, validateEmail, validateNameKatakana, isValidJoinDateLeaveDate } from "utils/validation"
import UnsaveConfirmPopup from "../../action/components/UnsaveConfirmPopup";

const initialErrors = { first_name: "", last_name: "", email: "", last_name_kana: "", first_name_kana: "", join_company_year: "" };

const BasicInformation = ({ onClose, selectedUser }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser)
  const [dayOptions, setDayOptions] = useState([{ id: -1, name: "" }])
  const talentMypage = useSelector((state: any) => state.talentMypage)
  const { first_name, last_name, id } = currentUser.talentInfo
  const talentInformation = talentMypage.talentDetail?.talent
  const { isLoading, actionStatus, successImage, actionName, initialBasicData } = useSelector((state: any) => state.talentMypage)
  const [isDisplay, setDisplay] = useState(false)
  const { talent, genderOptions, residenceOptions } = useSelector((state: any) => state.talentMypage)
  const [formData, setFormData] = useState(initialBasicData);
  const [isSubmit, setSubmit] = useState(false)
  const [unsaveConfirmOpen, setUnsaveConfirmOpen] = useState(false);
  const [errors, setErrors] = useState(initialErrors);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dataYear = getItemsYear(new Date().getFullYear() - WORKING_AGE, 100 - WORKING_AGE);
  const dataMonth = getItemsMonth();
  const dataDate = getItemsDay();
  const dataYearJoinLeave = getItemsYear(null);
  const dataMonthJoinLeave = getItemsMonth();
  const [dataDayJoinLeave, setDataDayJoinLeave] = useState(getItemsDay());
      
  const getValueByObject = (object: any) => {
    if (!object) {
      return null;
    }
    return object.id;
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
    setDisplay(true);
  }
  const handleBlurInput = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value.trim(),
    }));
  };
  const changeYearOfBirth = (value: any, name: any) => {
    let dateOfBirth = formData.birth_day
    
    if (value && getValueByObject(value)
      && formData.birth_month && getValueByObject(formData.birth_month)) {
      const dataDate = getItemsDay(
        getValueByObject(value),
        getValueByObject(formData.birth_month),
      );
      setDayOptions(dataDate);

      if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
        dateOfBirth = null
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      birth_day: dateOfBirth
    }));

    setDisplay(true)
  };

  const changeMonthOfBirth = (value: any, name: any) => {
    let dateOfBirth = formData.birth_day
    
    if (formData.birth_year && getValueByObject(formData.birth_year)
      && value && getValueByObject(value)) {
      const dataDate = getItemsDay(
        getValueByObject(formData.birth_year),
        getValueByObject(value),
      );
      setDayOptions(dataDate);

      if(dateOfBirth && !dataDate.some(item => item.id === dateOfBirth.id)) {
        dateOfBirth = null
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      birth_day: dateOfBirth
    }));

    setDisplay(true)
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const handleAvatarChange = async (file: any) => {
    if (!file) {
      setIsConfirmOpen(false);
      const data = {
        formData: {
          ...talentInformation,
          avatar: null,
          delete_avatar: true,
          change_point: 'image'
        },
      };
      await dispatch(updateBasicInformation(data))
      setSubmit(true)
    }
    setIsOpen(false);
  };
  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()
    if (isLoading) return

    // Validate
    let formErrors = {};
    const check_email = validateEmail(formData.email);
    if (check_email !== true) {
      formErrors.email = check_email
    }
    const check_first_name = validateRequired(formData.first_name, '名');
    if (check_first_name !== true) {
      formErrors.first_name = check_first_name
    }
    const check_last_name = validateRequired(formData.last_name, '姓');
    if (check_last_name !== true) {
      formErrors.last_name = check_last_name
    }
    let check_last_name_kana = validateRequired(formData.last_name_kana, 'セイ');
    if (check_last_name_kana !== true) {
      formErrors.last_name_kana = check_last_name_kana
    } else {
      check_last_name_kana = validateNameKatakana(formData.last_name_kana, 'セイ');
      if (check_last_name_kana !== true) {
        formErrors.last_name_kana = check_last_name_kana
      }
    }
    let check_first_name_kana = validateRequired(formData.first_name_kana, 'メイ');
    if (check_first_name_kana !== true) {
      formErrors.first_name_kana = check_first_name_kana
    } else {
      check_first_name_kana = validateNameKatakana(formData.first_name_kana, 'メイ');
      if (check_first_name_kana !== true) {
        formErrors.first_name_kana = check_first_name_kana
      }
    }
    const check_birth_day = validateRequired(formData.birth_day, '日');
    if (check_birth_day !== true) {
      formErrors.birth_day = check_birth_day
    }

    const check_join_company_date = isValidJoinDateLeaveDate(formData?.join_company_year?.id, formData.join_company_month?.id, formData.leave_company_year?.id, formData.leave_company_month?.id);
    if (check_join_company_date !== true) {
      formErrors.join_company_year = '入社年月は退社年月より後にできない。'
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    const data = {
      formData: {
        ...talentInformation,
        gender_id: formData?.gender?.id ? formData?.gender?.id : null,
        change_point: 'basicInform',
        last_name: formData.last_name,
        first_name: formData.first_name,
        first_name_kana: formData?.first_name_kana,
        last_name_kana: formData?.last_name_kana,
        email: formData?.email,
        city: getNameByObject(formData.city),
        join_company_year: formData?.join_company_year?.id ? formData?.join_company_year?.id : null,
        join_company_month: formData?.join_company_month?.id ? formData?.join_company_month?.id : null,
        leave_company_year: formData?.leave_company_year?.id ? formData?.leave_company_year?.id : null,
        leave_company_month: formData?.leave_company_month?.id ? formData?.leave_company_month?.id : null,
        leave_company_day: formData?.leave_company_day?.id ? formData?.leave_company_day?.id : null,
        birth_year: formData?.birth_year?.id ? formData?.birth_year?.id : null,
        birth_month: formData?.birth_month?.id ? formData?.birth_month?.id : null,
        birth_day: formData?.birth_day?.id ? formData?.birth_day?.id : null,
      }
    }
    await dispatch(updateBasicInformation(data))
    setSubmit(true)
    const dataTalent = {
      id: Number(id),
    }
    setDisplay(false)
    setErrors(initialErrors)
    onClose();
  }
  useEffect(() => {
    if (talent) {
      setDayOptions(getItemsDay(talent?.birth_year, talent?.birth_month));
      setDataDayJoinLeave(getItemsDay(talent?.last_company?.leave_company_year, talent?.last_company?.leave_company_month))
      setFormData({
        last_name_kana: talent?.last_name_kana || '',
        first_name_kana: talent?.first_name_kana || '',
        email: talent?.email || '',
        last_name: talent?.last_name || '',
        first_name: talent?.first_name || '',
        gender: talent?.gender,
        city: getObjectByName(talent?.city, residenceOptions),
        join_company_year: getObjectById(talent?.last_company?.join_company_year, dataYearJoinLeave),
        join_company_month: getObjectById(talent?.last_company?.join_company_month, dataMonthJoinLeave),
        leave_company_year: getObjectById(talent?.last_company?.leave_company_year, dataYearJoinLeave),
        leave_company_month: getObjectById(talent?.last_company?.leave_company_month, dataMonthJoinLeave),
        leave_company_day: getObjectById(talent?.last_company?.leave_company_day, dataDayJoinLeave),
        birth_year: getObjectById(talent?.birth_year, dataYear),
        birth_month: getObjectById(talent?.birth_month, dataMonth),
        birth_day: getObjectById(talent?.birth_day, dataDate),
      })
    }
  }, [talent]);
  const changeYearOfLeave = (value: any) => {
      let leave_company_day = formData.leave_company_day
      if(value && getValueByObject(value) && formData.leave_company_month && getValueByObject(formData.leave_company_month)) {
          const dataDate = getItemsDay(
              getValueByObject(value),
              getValueByObject(formData.leave_company_month),
          );
          setDataDayJoinLeave(dataDate)
      
          if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
            leave_company_day = null
          }
      }
      setFormData((prev) => ({ 
          ...prev, 
          leave_company_year: value, 
          leave_company_day: leave_company_day 
      }))
  };
  const changeMonthOfLeave = (value: any) => {
      let leave_company_day = formData.leave_company_day
      if(formData.leave_company_year && getValueByObject(formData.leave_company_year) && value && getValueByObject(value)) {
          const dataDate = getItemsDay(
              getValueByObject(formData.leave_company_year),
              getValueByObject(value),
          );
          setDataDayJoinLeave(dataDate)

          if(leave_company_day && !dataDate.some(item => item.id === leave_company_day.id)) {
            leave_company_day = null
          }
      }
      setFormData((prev) => ({ 
          ...prev, 
          leave_company_month: value, 
          leave_company_day: leave_company_day 
      }))
  };
  return (
    <>
      <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
        <div className="flex items-center justify-between px-4 mb-1">
          <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">
            基本情報の編集
          </h2>
          <CustomIconButton onClick={() => !isDisplay ? onClose() : setUnsaveConfirmOpen(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_8574_265)">
                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
              </g>
              <defs><clipPath id="clip0_8574_265"><rect width="24" height="24" fill="white" /></clipPath></defs>
            </svg>
          </CustomIconButton>
        </div>
        <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
          <form className="mt-6 w-full flex flex-col">
            <div className="mb-10 inline-flex items-center gap-6">
              <div className="relative shrink-0">
                <img onClick={() => setIsOpen(true)}
                  src={talent?.avatar ? talent?.avatar : noAvatar} alt="Avatar" className="w-20 h-20 rounded-full object-cover" />
                <button type="button" onClick={() => setIsOpen(true)} className="absolute bottom-[-10px] right-[-10px] z-index[9rem] p-1 bg-white rounded-full hover:cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clipPath="url(#clip0_13103_9111)">
                      <path d="M9.99967 12.6693C11.4724 12.6693 12.6663 11.4754 12.6663 10.0026C12.6663 8.52984 11.4724 7.33594 9.99967 7.33594C8.52691 7.33594 7.33301 8.52984 7.33301 10.0026C7.33301 11.4754 8.52691 12.6693 9.99967 12.6693Z" fill="#808080" />
                      <path d="M7.50033 1.66406L5.97533 3.33073H3.33366C2.41699 3.33073 1.66699 4.08073 1.66699 4.9974V14.9974C1.66699 15.9141 2.41699 16.6641 3.33366 16.6641H16.667C17.5837 16.6641 18.3337 15.9141 18.3337 14.9974V4.9974C18.3337 4.08073 17.5837 3.33073 16.667 3.33073H14.0253L12.5003 1.66406H7.50033ZM10.0003 14.1641C7.70033 14.1641 5.83366 12.2974 5.83366 9.99739C5.83366 7.6974 7.70033 5.83073 10.0003 5.83073C12.3003 5.83073 14.167 7.6974 14.167 9.99739C14.167 12.2974 12.3003 14.1641 10.0003 14.1641Z" fill="#808080" />
                    </g>
                    <defs><clipPath id="clip0_13103_9111"><rect width="20" height="20" fill="white" /></clipPath></defs>
                  </svg>
                </button>
              </div>
              <p className="alu-text-base-2 text-xl font-bold flex-1 break-all">{formatName(first_name, last_name)}</p>
            </div>
            <div className="w-full">
              <h3 className="mb-4 alu-text-base-2 font-bold text-base">基本情報</h3>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="fullName">氏名</label>
                <div className="flex items-top gap-2">
                  <div>
                    <TextInput
                      size="md"
                      error={errors.last_name}
                      errorText={errors.last_name}
                      id="last_name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      onBlur={handleBlurInput}
                      placeholder="姓"
                      maxLength={100}
                    />
                  </div>
                  <div>
                    <TextInput
                      size="md"
                      error={errors.first_name}
                      errorText={errors.first_name}
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      onBlur={handleBlurInput}
                      placeholder="名"
                      maxLength={100}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="katakanaName">
                  氏名（カナ）
                </label>
                <div className="flex items-top gap-2">
                  <div>
                    <TextInput
                      size="md"
                      error={errors.last_name_kana}
                      errorText={errors.last_name_kana}
                      id="last_name_kana"
                      name="last_name_kana"
                      value={formData.last_name_kana}
                      onChange={handleChange}
                      onBlur={handleBlurInput}
                      placeholder="セイ"
                      maxLength={100}
                    />
                  </div>
                  <div>
                    <TextInput
                      size="md"
                      error={errors.first_name_kana}
                      errorText={errors.first_name_kana}
                      id="first_name_kana"
                      name="first_name_kana"
                      value={formData.first_name_kana}
                      onChange={handleChange}
                      onBlur={handleBlurInput}
                      placeholder="メイ"
                      maxLength={100}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1 pointer-events-none" htmlFor="email">
                  メールアドレス
                </label>
                <TextInput
                  size="md"
                  error={errors.email}
                  errorText={errors.email}
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlurInput}
                  placeholder="sample@sample.com"
                  maxLength={254}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="dateOfBirth" >
                  生年月日
                </label>
                <div className="flex items-top gap-2">
                  <div className="w-1/3">
                    <Dropdown
                      inputWidth="full"
                      placeholder={talent?.birth_year ? talent?.birth_year : '年'}
                      options={dataYear}
                      value={formData.birth_year}
                      onChange={(value: any) => changeYearOfBirth(value, "birth_year")}
                      unitLabel="年"
                      isUnitLabelHavingMargin={false}
                    />
                  </div>
                  <div className="w-1/3">
                    <Dropdown
                      inputWidth="full"
                      placeholder={talent?.birth_month ? talent?.birth_month : '月'}
                      options={dataMonth}
                      value={formData.birth_month}
                      onChange={(value: any) => changeMonthOfBirth(value, "birth_month")}
                      unitLabel="月"
                    />
                  </div>
                  <div className="w-1/3">
                    <Dropdown
                      inputWidth="full"
                      placeholder='日'
                      error={errors.birth_day}
                      errorText={errors.birth_day}
                      options={dayOptions}
                      value={formData.birth_day}
                      onChange={(value: any) => {
                        setFormData((prev) => ({ ...prev, birth_day: value }));
                        setDisplay(true);
                      }}
                      unitLabel="日"
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="department" >
                  居住地
                </label>
                <Dropdown
                  customStyle="!min-w-[8.0625rem]"
                  placeholder='選択してください'
                  options={residenceOptions}
                  value={formData.city}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, city: value }))
                    setDisplay(true)
                  }
                  }
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="department" >
                  性別
                </label>
                <Dropdown
                  customStyle="!min-w-[8.0625rem]"
                  placeholder='選択してください'
                  options={genderOptions}
                  value={formData.gender}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, gender: value }))
                    setDisplay(true)
                  }
                  }
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1">
                  {talent?.last_company?.name}に在籍した期間
                </label>
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="department">
                  入社年月
                </label>
                <div className="flex items-top">
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataYearJoinLeave}
                      value={formData.join_company_year}
                      unitLabel="年"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, join_company_year: value })); setDisplay(true);}}
                    />
                  </div>
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataMonthJoinLeave}
                      value={formData.join_company_month}
                      unitLabel="月"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, join_company_month: value })); setDisplay(true);}}
                    />
                  </div>
                  <div className="w-1/3 mt-2">〜</div>
                </div>
                <div className="flex items-top items-center">
                  {errors.join_company_year && (<p className="alu-text-error text-sm mt-2">{errors.join_company_year ? `*${errors.join_company_year}` : ""}</p>)}
                </div>
              </div>
              <div className="mb-4">
                <label className="block mb-1 text-sm alu-text-base-1" htmlFor="department">
                  退社年月日
                </label>
                <div className="flex items-top">
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataYearJoinLeave}
                      value={formData.leave_company_year}
                      unitLabel="年"
                      onChange={(value: any) => {changeYearOfLeave(value); setDisplay(true);} }
                    />
                  </div>
                  <div className="w-1/3 mr-2">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataMonthJoinLeave}
                      value={formData.leave_company_month}
                      unitLabel="月"
                      onChange={(value: any) => {changeMonthOfLeave(value); setDisplay(true);} }
                    />
                  </div>
                  <div className="w-1/3">
                    <Dropdown
                      inputWidth="full"
                      placeholder={"ー"}
                      options={dataDayJoinLeave}
                      value={formData.leave_company_day}
                      unitLabel="日"
                      onChange={(value: any) => {setFormData((prev) => ({ ...prev, leave_company_day: value })); setDisplay(true);}}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 mb-10 w-fit">
                <Link to={'/talent/mypage/change-password'} target="_blank">
                  <span className="fcursor-pointer flex gap-2 alu-text-title text-sm items-center p-1 rounded hover:bg-[#FFF3E5] w-fit">
                    パスワードを変更
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" >
                      <path
                        d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
                        fill="#FF861A"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
            <div className="flex items-center justify-between gap-4">
              <CustomButton type="button" onClick={() => onClose()} width="full" variant="outline" size="md">
                キャンセル
              </CustomButton>
              <CustomButton onClick={handleSave} type="button" disabled={isLoading || !isDisplay} width="full" size="md">
                <p>{isLoading ? "保存中..." : "保存"}</p>
                {isLoading && (<span><LoadingSpinner /></span>)}
              </CustomButton>
            </div>
          </form>
        </div>
      </div>
      {isOpen && <AvatarDialog open={isOpen} onClose={() => setIsOpen(false)} onConfirm={handleAvatarChange} onConfirmPopupOpen={() => setIsConfirmOpen(true)} />}
      {isConfirmOpen && <ConfirmPopup open={isConfirmOpen} onClose={() => setIsConfirmOpen(false)} confirmContent={"現在使用しているプロフィール画像を削除しますか？"} onConfirm={() => handleAvatarChange(null)} isLoading={isLoading} />}
      {unsaveConfirmOpen && <UnsaveConfirmPopup
        open={unsaveConfirmOpen}
        onClose={() => setUnsaveConfirmOpen(false)}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => onClose()}
      />}
    </>
  );
};
export default BasicInformation;